import { Component, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { FormBuilder, FormControl, FormGroup } from '@angular/forms';
import { MatPaginator, MatSort, MatTableDataSource } from '@angular/material';
import * as pdfMake from 'pdfmake/build/pdfmake';
import * as pdfFonts from 'pdfmake/build/vfs_fonts';
// tslint:disable-next-line: import-blacklist
import { ReplaySubject } from 'rxjs/ReplaySubject';
import { Subscription } from 'rxjs/Subscription';
import Swal from 'sweetalert2';
import { Person } from '../../models/person';
import { CalendarService } from '../../services/calendar.service';
import { LogService } from '../../services/shared/log.service';
import { NGaugeService } from '../../services/shared/ngauge.service';
import { NotesService } from '../../services/shared/notes.service';
import { TechService } from '../../services/tech.service';
import { UserService } from '../../services/user.service';
import { CORPORATE, LOG_LEVELS, SUPER_ADMIN, TEXT_AREA_TOOL_TIP } from '../../util/constants';
import { DateUtil } from '../../util/dateUtil';

@Component({
  selector: 'app-notification',
  templateUrl: './notification.component.html',
  styleUrls: ['./notification.component.scss']
})

export class NotificationComponent implements OnInit, OnDestroy {

  today: Date = new Date();
  startDate: any;
  endDate: any;
  notesDetail: any;
  currentTime: any;
  notifications = [];
  notesAction: any;
  updateNotes: any;
  updateNotesAction: any;
  notificationData: FormGroup;
  getUserData: any;
  showTraceDetail: any;
  traceResult = [];
  minEndDate = new Date();
  noTraceShown = true;
  userType: any;
  superAdmin = SUPER_ADMIN;
  displayedColumns = ['name', 'targetType', 'saType'];
  i = 1;
  dataSource: MatTableDataSource<any>;
  @ViewChild(MatPaginator) paginator: MatPaginator;
  @ViewChild(MatSort) sort: MatSort;
  searchNotificationForm: FormGroup;
  salesPersons = [];
  showGenReport = false;
  backupSalesPerson: any[];
  weekNotifications: any;
  todaysDate: any;
  notesdata: any;
  showOption = 'Show';
  filteredSalesPerson: ReplaySubject<Person[]> = new ReplaySubject<Person[]>(1);
  spFilterCtrl: FormControl = new FormControl();
  salesPersonsList: ReplaySubject<Person[]> = new ReplaySubject<Person[]>(1);
  spsFilterCtrl: FormControl = new FormControl();
  propertyType: any;
  corporate = CORPORATE;
  textToolTip = TEXT_AREA_TOOL_TIP;
  selectedIndex = 0;
  isCluster = false;

  getAdminUserSubscription: Subscription;
  saveNotesSubscription: Subscription;
  getNotesSubscription: Subscription;
  getLastFiveWeekSubscription: Subscription;
  searchNotificationSubscription: Subscription;
  getAlertSubscription: Subscription;
  notesSubscription: Subscription;
  notesActionSubscription: Subscription;
  updateNotesSubscription: Subscription;
  updateAlertSubscription: Subscription;
  updateNotSubscription: Subscription;
  getReportedIssueSubscription: Subscription;
  getSuggestionSubscription: Subscription;
  notifyWarning: string;
  mergedData = [];

  constructor(private formBuilder: FormBuilder,
    private calendarService: CalendarService,
    private userService: UserService,
    private logService: LogService,
    private techService: TechService,
    private notesService: NotesService,
    private ngaugeService: NGaugeService) {
    pdfMake.vfs = pdfFonts.pdfMake.vfs;
  }

  ngOnInit() {
    this.searchNotificationForm = this.buildSearchNotifyForm();
    this.notificationData = this.buildNotificationForm();
    this.userType = this.userService.getLoggedInUserType();
    this.propertyType = this.userService.getLoggedInPropertyType();
    this.getNotifications();
    this.getSalesPerons();
    this.startDate = DateUtil.getFormatted1stDayOfTheMonth(new Date());
    this.endDate = DateUtil.getFormattedLastDayOfTheMonth(new Date());
    this.notesSubscription = this.calendarService.getNotes().subscribe(notesData => {
      this.updateNotes = notesData;
    });
    this.notesActionSubscription = this.calendarService.getNotesAction().
      subscribe(action => {
        this.updateNotesAction = action;
      });
    this.isCluster = this.ngaugeService.getIsClusterProperty();
  }

  buildNotificationForm() {
    return this.formBuilder.group({
      textArea: [''],
      startDate: [''],
      endDate: ['']
    });
  }

  buildSearchNotifyForm() {
    return this.formBuilder.group({
      fromDate: '',
      toDate: '',
      findSalesPerson: '',
      filterSalesPerson: ''
    });
  }

  async getNotifications() {
    this.todaysDate = DateUtil.getFormattedDate(this.today);
    const propertyType = this.userService.getLoggedInPropertyType();
    if (propertyType === CORPORATE) {
      await this.getHelpCenterIssues();
    }
    this.getNotesSubscription = this.notesService.getNotes(this.todaysDate).
      subscribe((alerts: any) => {
        const userId = this.userService.getLoggedInUserId();
        alerts['result'] = alerts['result'].sort((a, b) => b.id - a.id);
        this.getAlertSubscription = this.notesService.getReportNotification(userId).subscribe((response: any) => {
          alerts['result'].forEach(alert => {
            if (alert['type'] === 'propertyalert') {
              alert['type'] = 'Property Alert';
            } else if (alert['type'] === 'clusteralert') {
              alert['type'] = 'Cluster Alert';
            }
          });
          this.notesdata = alerts;
          response.forEach((res: any) => {
            res['type'] = res['title'];
            res['toolTip'] = true;
          });
          this.notifications = alerts['result'].concat(response);
        }, error => {
          this.logService.logError(LOG_LEVELS.ERROR, 'Notification Component', 'On Fetch Alerts', JSON.stringify(error));
        });
      }, error => {
        this.logService.logError(LOG_LEVELS.ERROR, 'Notification Component', 'On Fetch Notes', JSON.stringify(error));
      });
  }

  getHelpCenterIssues(): Promise<void> {
    return new Promise(resolve => {
      this.getReportedIssueSubscription = this.notesService.getReportedIssues().
        subscribe(async (data: any) => {
          this.getSuggestionSubscription = this.notesService.getSuggestEnhancements().
            subscribe(async (data1: any) => {
              if (data.length > 0 || data1.length > 0) {
                data = data.filter(val => val.updatedOn !== null);
                data1 = data1.filter(val => val.updatedOn !== null);
                let lastNotifyDate = new Date();
                if (data.length > 0 && data1.length > 0) {
                  lastNotifyDate = new Date(data[0].updatedOn).getTime() < new Date(data1[0].updatedOn).getTime() ?
                    new Date(data[0].updatedOn) : new Date(data1[0].updatedOn);
                } else if (data.length > 0) {
                  lastNotifyDate = new Date(data[0].updatedOn);
                } else if (data1.length > 0) {
                  lastNotifyDate = new Date(data1[0].updatedOn);
                }
                this.mergedData = data.concat(data1);
                const dateDiff = DateUtil.getDiffBetween2days(lastNotifyDate, new Date());
                const newDate = dateDiff > 7 ? this.getFormatedDate(lastNotifyDate) : dateDiff + ' Days';
                this.notifyWarning = `${this.mergedData.length} Pending request since ${newDate}`;
                resolve();
              }
            });
        });
    });
  }

  getFormatedDate(d) {
    d = new Date(d);
    const months = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
    const date = d.getDate();
    const month = d.getMonth();
    const year = d.getFullYear();
    return `${date} ${months[month]} ${year}`;
  }

  gotoHelpCenter() {
    this.techService.publishCloseSideNavTriggerer('close');
    this.ngaugeService.routeTo('helpCenter');
  }

  formulateNotification(notifications) {
    this.weekNotifications = [];
    this.salesPersons = [];
    const filteredNotification = [];
    if (notifications.length > 0) {
      notifications.forEach(notification => {
        if (Number(notification['appointmentPending']) > 0) {
          const userData = this.pushToNotify(notification['adminuser'], notification['type'], 'Appointment Call',
            notification['startDate'], notification['endDate'], notification['appointmentTarget'],
            notification['appointmentComplete'], notification['appointmentPending']);
          filteredNotification.push(userData);
        }
        if (Number(notification['prospectingPending']) > 0) {
          const userData = this.pushToNotify(notification['adminuser'], notification['type'], 'Prospecting Call',
            notification['startDate'], notification['endDate'], notification['prospectingTarget'],
            notification['prospectingComplete'], notification['prospectingPending']);
          filteredNotification.push(userData);
        }
      });
      this.weekNotifications = this.salesPersons = filteredNotification;
      this.salesPersons = this.ngaugeService.removeArrayDuplicates(filteredNotification, 'userName');
      this.ngaugeService.buildFilter(this.spFilterCtrl, this.filteredSalesPerson, this.salesPersons, 'userName');
    }
    this.groupByType(filteredNotification);
  }

  groupByType(notifications) {
    const myArray1 = notifications.reduce((previous, current) => {
      if (!previous[current['type']]) {
        previous[current['type']] = [current];
      } else {
        previous[current['type']].push(current);
      }
      return previous;
    }, {});
    const groupedCharges = Object.keys(myArray1).map(key => ({ key, value: myArray1[key] }));
    let notificationData = [];
    if (groupedCharges.length > 0) {
      notificationData.push(...groupedCharges.filter(chargers => chargers.key === 'Week').map(z => z.value));
      notificationData.push(...groupedCharges.filter(chargers => chargers.key === 'Month').map(z => z.value));
      notificationData.push(...groupedCharges.filter(chargers => chargers.key === 'Quarter').map(z => z.value));
      notificationData = [].concat(...notificationData);
    }
    this.dataSource = new MatTableDataSource<Account>(notificationData);
  }

  getSalesPerons() {
    this.getAdminUserSubscription = this.userService.getActiveusers().subscribe((userInfo: any) => {
      this.ngaugeService.buildFilter(this.spsFilterCtrl, this.salesPersonsList, userInfo, 'userName');
    }, error => {
      this.logService.logError(LOG_LEVELS.ERROR, 'Notification Component', 'On Fetch User', JSON.stringify(error));
    });
  }

  checkFromDate(fromDate) {
    this.searchNotificationForm.controls['toDate'].setValue('');
    if (fromDate !== null) {
      this.minEndDate = DateUtil.getNewDate(fromDate);
      this.searchNotificationForm.get('findSalesPerson').setValue('');
    } else {
      this.minEndDate = new Date();
      this.searchNotificationForm.patchValue({ fromDate: new Date() });
      this.ngaugeService.toastrError('Invalid date found');
    }
  }

  checkToDate(toDate) {
    const fromDate = DateUtil.getDateInYYYYMMDD(this.searchNotificationForm.value.fromDate);
    if (toDate === null) {
      this.searchNotificationForm.patchValue({
        toDate: fromDate
      });
      this.ngaugeService.toastrError('Invalid date found');
    }
  }

  changeStartDate(date) {
    if (date !== null) {
      this.minEndDate = date;
      this.notificationData.get('endDate').setValue(date);
    } else {
      this.ngaugeService.toastrError('Invalid Date Found');
      this.notificationData.get('startDate').setValue('');
    }
  }

  changeEndDate(date) {
    if (date === null) {
      this.ngaugeService.toastrError('Invalid Date Found');
      this.notificationData.get('endDate').setValue('');
    }
  }

  createNotes(notesType, type) {
    if (notesType.startDate !== '' && notesType.endDate !== '' && notesType.textArea !== '') {
      const currentTime = DateUtil.getFullTime(new Date());
      this.notesDetail = {
        'startDate': DateUtil.getDateInYYYYMMDD(notesType.startDate),
        'endDate': DateUtil.getDateInYYYYMMDD(notesType.endDate),
        'type': type,
        'name': 'ngauge',
        'message': notesType.textArea,
        'time': currentTime.trim(),
        'status': 'notread'
      };
      const property = this.userService.getLoggedInUserProperty();
      this.notesDetail['property'] = property;
      if (this.updateNotesAction === 'Update') {
        this.notesDetail['id'] = this.updateNotes['id'];
        if (this.notificationData.dirty) {
          const swalObject1 = {
            title: '<strong>Are you sure</strong>',
            text: 'Do you want to update it',
            confirmButtonText: 'Yes, Update it!',
            cancelButtonText: 'No'
          };
          const updateNotification = this.ngaugeService.swalOkCancelButton(swalObject1);
          Swal(updateNotification).then((result) => {
            if (result.value) {
              this.updateNotesSubscription = this.calendarService.saveNotes(this.notesDetail).subscribe(() => {
                this.getNotifications();
                this.calendarService.getAllNotes(this.startDate, this.endDate);
                this.resetNotes();
              }, error => {
                this.logService.logError(LOG_LEVELS.ERROR, 'Notification Component', 'On Update Notes', JSON.stringify(error));
              });
              this.ngaugeService.toastrSuccess('Alert updated successfully');
            }
          });
        }
      } else {
        const swalObject1 = {
          title: '<strong>Are you sure</strong>',
          text: 'Do you want to create it',
          confirmButtonText: 'Yes, Create it!',
          cancelButtonText: 'No'
        };
        const updateNotification = this.ngaugeService.swalOkCancelButton(swalObject1);
        Swal(updateNotification).then((result) => {
          if (result.value) {
            this.saveNotesSubscription = this.calendarService.saveNotes(this.notesDetail).subscribe(() => {
              this.resetNotification();
            }, error => {
              this.resetNotification();
            });
            this.ngaugeService.toastrSuccess('Alert created successfully');
          }
        });
      }
      if (type === 'Company Wide Alert') {
        this.logService.logUserActivity(LOG_LEVELS.INFO, 'Notification - Alerts - Send', 'Company Wide Alert');
      } else {
        this.logService.logUserActivity(LOG_LEVELS.INFO, 'Notification - Alerts - Send', 'Property');
      }
    } else {
      this.ngaugeService.toastrError('Please enter all fields');
    }
  }

  resetNotification() {
    this.getNotifications();
    this.calendarService.getAllNotes(this.startDate, this.endDate);
    this.resetNotes();
  }

  pushToNotify(adminUser, type, saType, startDate, endDate, target, complete, pending) {
    return {
      userName: `${adminUser['firstName']} ${adminUser['lastName']}`,
      type: type,
      salesActivityType: saType,
      salesPersonId: adminUser['id'],
      startDate: startDate,
      endDate: endDate,
      target: target,
      accomplishment: complete,
      pending
    };
  }

  refreshSalesActivities() {
    this.searchNotificationForm = this.buildSearchNotifyForm();
    const currentDate = DateUtil.getFormattedDate(new Date());
    if (this.selectedIndex === 0) {
      this.getLastFiveWeekSubscription = this.notesService.getLastFiveWeeksNotification(currentDate).subscribe((notifications: any) => {
        notifications = notifications['result'];
        this.formulateNotification(notifications);
      }, error => {
        this.logService.logError(LOG_LEVELS.ERROR, 'Notification Component', 'On Fetch Last Five Week Data', JSON.stringify(error));
      });
    } else {
      this.formulateNotification([]);
    }
  }

  searchSalesActivitiesBySalesPerson(salesPersonId) {
    if (this.searchNotificationForm.value.fromDate !== '' && this.searchNotificationForm.value.toDate !== '') {
      const fromDate = DateUtil.getDateInYYYYMMDD(this.searchNotificationForm.value.fromDate);
      const toDate = DateUtil.getDateInYYYYMMDD(this.searchNotificationForm.value.toDate);
      this.searchNotificationSubscription = this.notesService.searchNotifications(fromDate, toDate, salesPersonId).
        subscribe(notifications => {
          this.formulateNotification(notifications['result']);
        }, error => {
          this.logService.logError(LOG_LEVELS.ERROR, 'Notification Component', 'On Search Notification', JSON.stringify(error));
        });
    } else {
      this.searchNotificationForm.get('findSalesPerson').setValue('');
      this.ngaugeService.toastrError('Please select all fields to generate report');
    }
  }

  searchSalesActivitiesFromTable(salesPersonName) {
    this.salesPersons = this.weekNotifications;
    const persons = this.salesPersons.filter(person =>
      person['userName'] === salesPersonName);
    this.salesPersons = this.ngaugeService.removeArrayDuplicates(this.salesPersons, 'userName');
    this.salesPersons = this.ngaugeService.sortByContent(this.salesPersons, 'userName');
    this.groupByType(persons);
  }

  showHideGenReport() {
    this.showGenReport = !this.showGenReport;
    if (!this.showGenReport) {
      this.showOption = 'Show';
    } else {
      this.showOption = 'Hide';

    }
  }

  editNotes(notes) {
    if (notes.about !== undefined) {
      this.updateNotSubscription = this.notesService.updateNotification(notes.id).subscribe(() => {
        notes.value = notes;
        notes.title = notes.about;
        this.techService.publishSideNavTriggerer({
          title: notes['about'], value: Number(notes['reportId']),
          property: notes['property'], view: 'Edit', from: 'notification'
        });
      });
      return;
    }
    /* this.notesAction = 'Update';
    this.calendarService.setNotesAction(this.notesAction);
    this.calendarService.setNotes(notes);
    this.notificationData = this.formBuilder.group({
      textArea: notes.message,
      startDate: DateUtil.getValidTimeZone(notes.startDate),
      endDate: DateUtil.getValidTimeZone(notes.endDate)
    }); */
    this.updateAlertSubscription = this.notesService.updateAlert(notes.id).subscribe(() => {
      this.notifications.forEach(note => {
        if (note['id'] === notes['id']) {
          note['status'] = 'read';
        }
      });
    });
  }

  resetNotes() {
    this.updateNotesAction = 'add';
    this.notificationData = this.buildNotificationForm();
    this.logService.logUserActivity(LOG_LEVELS.INFO, 'Notification - Alerts', 'Refresh');
  }

  resetSalesPerson() {
    this.searchNotificationForm.controls['salesPerson'].setValue('');
  }

  blockAlpha(event) {
    this.ngaugeService.blockAlpha(event);
  }

  async printReport(title) {
    if (this.dataSource.filteredData.length === 0) {
      return;
    }
    const data = await this.generateTableBody();
    const documentDefinition = {
      content: [
        {
          text: title + ' Performance Report',
          style: 'header',
          alignment: 'center'
        },
        {
          style: 'tableExample',
          table: {
            widths: ['*', 90, 35, 130, 22, '*', '*'],
            body: data
          }
        }
      ],
      styles: {
        header: {
          fontSize: 14,
          bold: true
        },
        tableExample: {
          fontSize: 10,
          margin: [0, 5, 0, 15]
        },
        tableHeader: {
          bold: true,
          fontSize: 10,
          color: 'black',
          margin: [0, 5, 0, 15]
        }
      }
    };
    const dateToday = DateUtil.getFormattedDateInMMDDYYYY(this.today);
    pdfMake.createPdf(documentDefinition).open();
    pdfMake.createPdf(documentDefinition).download(`${title}_Performance_Report-${dateToday}.pdf`);
  }

  generateTableBody() {
    return new Promise(resolve => {
      const data = [];
      data[0] = [
        { text: 'Name', style: 'tableHeader', alignment: 'center' },
        { text: 'Sales Activity Type', style: 'tableHeader', alignment: 'center' },
        { text: 'Target Type', style: 'tableHeader', alignment: 'center' },
        { text: 'Target Period', style: 'tableHeader', alignment: 'center' },
        { text: 'Goal', style: 'tableHeader', alignment: 'center' },
        { text: 'Accomplish- ment', style: 'tableHeader', alignment: 'center' },
        { text: 'Pending', style: 'tableHeader', alignment: 'center' }
      ];
      this.dataSource.filteredData.forEach(reportData => {
        const startDate = this.getFormattedDate(reportData['startDate']);
        const endDate = this.getFormattedDate(reportData['endDate']);
        data.push([
          { text: reportData['userName'] },
          { text: reportData['salesActivityType'] },
          { text: reportData['type'] },
          { text: `${startDate} - ${endDate}` },
          { text: reportData['target'], alignment: 'center' },
          { text: Number(reportData['accomplishment']) > 0 ? reportData['accomplishment'] : 0, alignment: 'center' },
          { text: Number(reportData['pending']) > 0 ? reportData['pending'] : 0, alignment: 'center' }
        ]);
      });
      resolve(data);
    });
  }

  getFormattedDate(date) {
    date = DateUtil.getValidTimeZone(date);
    return date !== '' ? DateUtil.getMomentDate(date) : '';
  }

  changeTabs(tabName) {
    if (tabName === 'Performance') {
      this.logService.logUserActivity(LOG_LEVELS.INFO, 'Performance', 'Click');
      const currentDate = DateUtil.getFormattedDate(new Date());
      this.getLastFiveWeekSubscription = this.notesService.getLastFiveWeeksNotification(currentDate).
        subscribe((notifications: any) => {
          notifications = notifications['result'];
          this.formulateNotification(notifications);
          this.selectedIndex = 0;
        }, error => {
          this.logService.logError(LOG_LEVELS.ERROR, 'Notification Component', 'On Fetch Last Five Week Data', JSON.stringify(error));
        });
    }
  }

  changeSubTabs(tabName) {
    if (tabName === 'Recent Targets') {
      this.selectedIndex = 0;
      this.refreshSalesActivities();
      this.logService.logUserActivity(LOG_LEVELS.INFO, 'Recent Targets', 'Click');
    } else if (tabName === 'Custom Report') {
      this.unSubscribe(this.getLastFiveWeekSubscription);
      this.selectedIndex = 1;
      this.refreshSalesActivities();
      this.logService.logUserActivity(LOG_LEVELS.INFO, 'Custom Report', 'Click');
    }
  }

  pasteClipboardContent(formGroup, formField) {
    let preValue = this[formGroup].get(formField).value;
    preValue = preValue === null ? '' : preValue;
    this.ngaugeService.getClipboardContent().then(text => {
      this[formGroup].get(formField).patchValue(preValue + text);
    });
  }

  ngOnDestroy() {
    this.unSubscribe(this.getReportedIssueSubscription);
    this.unSubscribe(this.getSuggestionSubscription);
    this.unSubscribe(this.notesSubscription);
    this.unSubscribe(this.notesActionSubscription);
    this.unSubscribe(this.updateNotesSubscription);
    this.unSubscribe(this.getAdminUserSubscription);
    this.unSubscribe(this.saveNotesSubscription);
    this.unSubscribe(this.getNotesSubscription);
    this.unSubscribe(this.getLastFiveWeekSubscription);
    this.unSubscribe(this.searchNotificationSubscription);
    this.unSubscribe(this.getAlertSubscription);
    this.unSubscribe(this.updateNotSubscription);
    this.unSubscribe(this.updateAlertSubscription);
    this.formBuilder = null;
    this.calendarService = null;
    this.userService = null;
    this.notesService = null;
    this.today = null;
    this.startDate = null;
    this.endDate = null;
    this.notesDetail = null;
    this.currentTime = null;
    this.notifications = null;
    this.notesAction = null;
    this.updateNotes = null;
    this.updateNotesAction = null;
    this.notificationData = null;
    this.getUserData = null;
    this.showTraceDetail = null;
    this.traceResult = null;
    this.minEndDate = null;
    this.noTraceShown = null;
    this.userType = null;
    this.superAdmin = null;
    this.displayedColumns = null;
    this.i = null;
    this.dataSource = null;
    this.paginator = null;
    this.sort = null;
    this.searchNotificationForm = null;
    this.salesPersons = null;
    this.showGenReport = null;
    this.backupSalesPerson = null;
    this.weekNotifications = null;
    this.todaysDate = null;
    this.notesdata = null;
    this.showOption = null;
    this.filteredSalesPerson = null;
    this.spFilterCtrl = null;
    this.salesPersonsList = null;
    this.spsFilterCtrl = null;
    this.textToolTip = null;
    this.calendarService = null;
    this.userService = null;
    this.logService = null;
    this.notesService = null;
    this.ngaugeService = null;
    this.corporate = null;
    this.propertyType = null;
    this.isCluster = null;
    this.notifyWarning = null;
    this.mergedData = null;
  }

  unSubscribe(subscription: Subscription) {
    if (this.ngaugeService.checkForNllUndef(subscription)) {
      subscription.unsubscribe();
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/core/notification/notification.component.ts